/**
 * Спрайты мини-игры (`public/game/`): SVG + PNG-лист геккона.
 * Учитывается `PUBLIC_URL` для деплоя не в корень домена.
 */

const FILES = {
  gecko: "gecko_full_spritesheet.png",
  lizard: "lizard.svg",
  smoke: "smoke.svg",
  smoke_blue: "smoke_blue.svg",
  smoke_gold: "smoke_gold.svg",
  coal: "coal.svg",
};

/** Лист 256×256, сетка 4×4, кадр 64×64 (см. `public/game/gecko_full_spritesheet.png`). */
export const GECKO = {
  frameW: 64,
  frameH: 64,
  cols: 4,
  rowIdle: 0,
  rowRun: 1,
  rowJump: 2,
  rowFall: 3,
};

/**
 * Чёрный фон листа → прозрачность (один раз при загрузке).
 * @param {HTMLImageElement} source
 * @param {number} thr порог по каждому каналу R,G,B
 */
function replaceNearBlackWithTransparent(source, thr) {
  const w = source.naturalWidth;
  const h = source.naturalHeight;
  if (!w || !h) {
    return Promise.resolve(source);
  }
  const c = document.createElement("canvas");
  c.width = w;
  c.height = h;
  const g = c.getContext("2d");
  if (!g) {
    return Promise.resolve(source);
  }
  g.drawImage(source, 0, 0);
  const imgData = g.getImageData(0, 0, w, h);
  const d = imgData.data;
  for (let i = 0; i < d.length; i += 4) {
    if (d[i] <= thr && d[i + 1] <= thr && d[i + 2] <= thr) {
      d[i + 3] = 0;
    }
  }
  g.putImageData(imgData, 0, 0);
  const next = new Image();
  next.decoding = "async";
  next.src = c.toDataURL("image/png");
  return new Promise((resolve, reject) => {
    next.onload = () => resolve(next);
    next.onerror = () => reject(new Error("gecko chroma decode"));
  });
}

/**
 * @returns {Promise<Record<string, HTMLImageElement>>}
 */
export async function loadGameSprites() {
  const root = `${process.env.PUBLIC_URL || ""}`.replace(/\/$/, "");
  /** Каждый файл отдельно: отсутствие PNG геккона (старый деплой) не ломает остальные спрайты. */
  const pairs = await Promise.all(
    Object.entries(FILES).map(
      ([key, file]) =>
        new Promise((resolve) => {
          const img = new Image();
          img.decoding = "async";
          img.onload = () => resolve([key, img]);
          img.onerror = () => resolve([key, null]);
          img.src = `${root}/game/${file}`;
        }),
    ),
  );
  const out = {};
  for (const [k, im] of pairs) {
    if (im && im.naturalWidth > 0) {
      out[k] = im;
    }
  }
  if (spriteReady(out.gecko)) {
    try {
      out.gecko = await replaceNearBlackWithTransparent(out.gecko, 22);
    } catch {
      /* оставляем исходник */
    }
  }
  return out;
}

export function spriteReady(img) {
  return Boolean(img && img.complete && img.naturalWidth > 0);
}
